// extracted by mini-css-extract-plugin
export default {"foodJournal":"FoodJournal_foodJournal__npPlC","loadMore":"FoodJournal_loadMore__cgCrQ"};